export class User {
     email?: string;
    password?: string;
    name?: string;
    roleName?: string;
    result?: string;
    createdBy?: string;
    createdDate?: string;
    modifiedBy?: string;
    modifiedDate?: string;
    id?: number;
    active?: boolean;
    isDelete?: number;
    selectedCategories?: string;
    roleID?: number;
    rememberMe?: boolean;

}



// WEBPACK FOOTER //
// ./src/app/Models/user.ts